module.exports = __webpack_public_path__ + "img/new-quiz.de312957.svg";